import { Recipe } from '@akin-home/recipes';
import { Meal } from '../types';
import { importRecipeToMeal } from './importRecipeToMeal';

export const replaceMealRecipe = (recipe: Recipe, meal: Meal): Meal =>
  importRecipeToMeal(recipe, { ...meal, recipes: [] });

/** Alias */
export const swapMealRecipe = replaceMealRecipe;
